<template>
     <div class="py-0 mt-4 mb-8">
        <v-container class="mx-0 my-0" style="padding:0 !important; max-width: 100% !important" v-if="appointment != null">
            <v-card class="mt-1 pt-1 pb-10 px-0 size" style="margin-bottom: 35px !important" align="center">   
                <v-row class="px-3 py-4 text-center" justify="center" align="center">
                    <v-col cols="6" class="py-1" justify="center" align="center">
                        <span justify="center" class="pr-1 text-uppercase blue_accent--text font-weight-bold">
                            {{ $t('process_pendings.enter_the_enclosure') }} 
                        </span> 
                    </v-col>
                </v-row>
                <v-col cols="6" justify="start" align="start" class="px-0">
                    <v-row>
                        <v-col cols="6" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text text--uppercase font-weight-bold" style="font-size:18px">
                                {{ $t('process_pendings.general_data') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.appointment') }}: </span> {{ this.id }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.client') }}: </span> {{ this.appointment.client.name }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.estimated_date_of_arriving') }}: </span> {{ this.appointment.arrival_date }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col v-if="$store.state.language == 'en'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.operation') }}: </span> {{ this.appointment.operation.description1 }} </v-col>
                         <v-col v-if="$store.state.language == 'es'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.operation') }}: </span> {{ this.appointment.operation.description }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.container') }}: </span> {{ this.appointment.container_number }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.description') }}: </span> {{ this.appointment.description }} </v-col>
                    </v-row>
                    <v-row>
                         <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.comments') }}: </span> {{ this.appointment.commentary }} </v-col>
                    </v-row>
                </v-col>
                <v-col class="py-5 px-0" cols="6" justify="start" align="start">
                    <v-row>
                        <v-col cols="12" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                                {{ $t('process_pendings.products') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <datatable :props="{headers:headers_sku, items: products}" @methodHandler="methodHandler"></datatable>   
                </v-col>
                <v-form ref="form" lazy-validation @submit.prevent="update">    
                    <v-col cols="6" justify="start" align="start" class="px-0">
                        <v-row>
                            <v-col cols="12" class="py-1">
                                <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                                    {{ $t('process_pendings.transport_details') }} 
                                </span>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-text-field v-model="appointment.carrier_line" :label="$t('process_pendings.carrier_line')" :rules="rules_required" ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-text-field v-model="appointment.drivers_name" :label="$t('process_pendings.drivers_name')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-text-field v-model="appointment.license_plate" :label="$t('process_pendings.plates')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-text-field v-model="appointment.tractor" :label="$t('process_pendings.tractor')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-text-field v-model="appointment.consignment_note" :label="$t('process_pendings.consignment_note')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-text-field v-model="appointment.seal_number" :label="$t('process_pendings.seal_number')" :rules="rules_required"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-autocomplete v-model="appointment.transport_type" :items="transport_types" :label="$t('process_pendings.type_transport')" ></v-autocomplete> 
                            </v-col>
                        </v-row>
                        <v-row class="px-3 pb-2" justify="start" align="center">
                            <v-col cols="8" class="px-0 py-0">
                                <span >{{ $t('process_pendings.unit_good_conditions') }}:</span>
                            </v-col>
                            <v-col cols="4" class="px-0 py-0">
                                <v-row justify="end" class="py-0 my-0 mx-0">
                                    <v-btn class="radio-left white--text" v-bind:color="appointment.unit_good_conditions == 0 ? 'blue_accent' : 'grey'" @click="appointment.unit_good_conditions = 0">{{ $t('process_pendings.false') }}</v-btn>
                                    <v-btn class="radio-right white--text" v-bind:color="appointment.unit_good_conditions == 1? 'blue_accent' : 'grey'" @click="appointment.unit_good_conditions = 1">{{ $t('process_pendings.true') }}</v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center" v-if="appointment.unit_good_conditions == 0">
                            <v-col cols="12" class="py-0">
                                <v-text-field v-model="appointment.unit_damage_specifications" :label="$t('process_pendings.unit_damage_specifications')" ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-3 pb-2" justify="start" align="center">
                            <v-col cols="8" class="px-0 py-0">
                                <span >{{ $t('process_pendings.seal_well_placed') }}:</span>
                            </v-col> 
                            <v-col cols="4" class="px-0 py-0">
                                <v-row justify="end" class="py-0 my-0 mx-0">
                                    <v-btn class="radio-left white--text" v-bind:color="appointment.seal_good_conditions == 0 ? 'blue_accent' : 'grey'" @click="appointment.seal_good_conditions = 0">{{ $t('process_pendings.false') }}</v-btn>
                                    <v-btn class="radio-right white--text" v-bind:color="appointment.seal_good_conditions == 1? 'blue_accent' : 'grey'" @click="appointment.seal_good_conditions = 1">{{ $t('process_pendings.true') }}</v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-form>
                <v-row align="center" class="mt-2" justify="center">
                    <v-col class="mb-1" cols="6" align="end" justify="end">
                        <btn-sf :label="'process_pendings.cancel'" class="mr-2" @click="back"></btn-sf>
                        <btn-sf :label="'process_pendings.enter_the_enclosure'" class="mr-2" @click="update('on-enclosure')" v-permission="'op_pendings.update'"></btn-sf>
                        <btn-pf :label="'process_pendings.enter_the_enclosure_and_continue'" @click="update('place-on-ramp')" v-permission="'op_pendings.update'"></btn-pf>
                    </v-col> 
                </v-row>
            </v-card>
            <bottom-bar ref="bottombar" :from="from" :m_type="m_type"></bottom-bar>         
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { appointmentShowUseCase } from '../../application/use_cases/appointment_show_use_case';
import { appointmentSetStatusUseCase } from '../../application/use_cases/appointment_set_status_use_case';
import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')];},
        headers_sku: function(){
            return [
                {text: this.$t('process_pendings.sku'), value: 'sku_p', class: 'text-uppercase'},
                // {text: this.$t('edit_appointment.description'), value: 'descripcion', class: 'text-uppercase'},
                {text: this.$t('process_pendings.pieces'), value: 'quantity', class: 'text-uppercase'},
                {text: this.$t('process_pendings.unit'), value: 'unit', class: 'text-uppercase'}
            ];
        }
    },
    data(){
        return {
            id: this.$route.params.id,
            from: this.$route.params.from,
            m_type: this.$route.params.m_type,
            snackbar: {
                visible: false,
                color: 'primary',
                timeout: 2000,
                text: ''
            },
            menu: false,
            transport_types:[
                "CAMIONETA 3 1/2",
                "RABÓN",
                "TORTHON",
                "CONTENEDOR 20'",
                "CONTENEDOR 40'",
                "CAJA SECA 40'",
                "CAJA SECA 48'",
                "CAJA SECA 53'",
                "OTROS"
            ],
            appointment: null,
            products: [],
            racks: []
        }
    },
    mounted(){
        localStorage.setItem('bottom', 0);
        this.$store.state.bottom = 0;
        this.$store.state.module = "headers.enter_to_enclosure_operation";
        this.index();
    },
    methods: {
        back(){
            this.$router.go(-1);
        },
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        async index(){
            try{
                this.appointment = await appointmentShowUseCase(this.id, HttpAppointmentRepository);
                this.appointment.products = [];

                await this.loadProducts();
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async loadProducts() {
            if(this.appointment.operation.format_type == "Entrada"){
                if(this.appointment.unknown_products == true){
                    var p = {};
                    if(this.appointment.standby_products[0].attributes.unknownProducts.boxes > 0){
                        console.log("OKOKK")
                        p = {
                            sku_p: this.$t('process_pendings.boxes'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.boxes
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.pallets > 0){
                        p = {
                            sku_p: this.$t('process_pendings.pallets'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.pallets
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.containers > 0){
                        p = {
                            sku_p: this.$t('process_pendings.containers'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.containers
                        }
                        this.products.push(p);
                    }
                }
                else{
                    this.appointment.standby_products.forEach(x => 
                    {
                        x = x.attributes;
                        var p = {};
                        p = {
                            sku_p: x.product.sku,
                            quantity: x.quantity,
                            unit: x.product.unit
                        }
                                    
                        this.products.push(p);
                    });
                }
            } 
            else if(this.appointment.operation.format_type == "Salida"){
                this.appointment.detail_orders.forEach(x => 
                {
                    x = x.attributes;
                    var p = {};
                    p = {
                        sku_p: x.product.sku,
                        quantity: x.expected,
                        unit: x.product.unit
                    }
                                
                    this.products.push(p);
                });
            }
        },
        async update(url){
            const valid = this.$refs.form.validate();
            if(valid){
                try{
                    this.appointment.newStatus = 'En recinto';
                    this.appointment.status = 'En recinto';
                    
                    const res = await appointmentSetStatusUseCase(this.id, this.appointment, HttpAppointmentRepository);
                    res;
                    if(url == "on-enclosure") this.$router.push('/operation/' + url + '/' + this.from + '/' + this.m_type);
                    else this.$router.push('/operation/' + url + '/' + this.id + '/' + this.from + '/' + this.m_type);
                } catch (e) {
                    console.log(e);
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.message
                    }
                }
            } else {
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('process_pendings.missing_required_fields')
                }
            }
        },
    },
    watch:{
    }
}
</script>

<style lang="scss">
</style>